export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.06064bd1.png";